import React, { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import Topbar from './Topbar'
import Scrollbar from '../../shared/ScrollBar'

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    height: 'calc(100vh - 110px)',
    [theme.breakpoints.down('1280')]: {
      height: 'calc(100vh - 94px)',
    },
  },
}))

export default (Minimal) => {
  const Hoc = ({ ...props }) => {
    const { className } = props
    const classes = useStyles()
    const scrollRef = useRef()
    const [showButton, setShowButton] = useState()
    const respondToVisibility = (element, callback) => {
      const options = {
        root: document.documentElement,
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          callback(entry.intersectionRatio > 0)
        })
      }, options)
      if (element) {
        observer.observe(element)
      }
    }

    function isVisible(domElement) {
      return new Promise((resolve) => {
        if (!domElement) {
          resolve(true)
          return
        }
        const observeData = new IntersectionObserver(([entry]) => {
          resolve(entry.intersectionRatio === 1)
          observeData.disconnect()
        })
        observeData.observe(domElement)
      })
    }

    useEffect(() => {
      if (scrollRef) {
        window.addEventListener('scroll', handleScroll)
        respondToVisibility(document.getElementById('myEle'), () => {})
      }
    }, [scrollRef])

    const handleScroll = async () => {
      const visible1 = await isVisible(document.querySelector('#myEle1'))
      const visible2 = await isVisible(document.querySelector('#myEle2'))
      setShowButton(!(visible1 || visible2))
    }

    return (
      <div className={clsx(classes.root, className)}>
        <Topbar showButton={showButton} />
        <div className={classes.content}>
          <Scrollbar onScroll={handleScroll} scrollRef={scrollRef}>
            <Minimal {...props} />
          </Scrollbar>
        </div>
      </div>
    )
  }
  return Hoc
}
